module.exports = __webpack_public_path__ + "static/img/img-home-co-23.0061cda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-23.png
// module id = bm6n
// module chunks = 1